import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * RL-1820: the last admin page opened before Help, so "Report a problem" can
 * say which page the problem was on. In memory only (nothing stored).
 */
let lastPath: string | null = null;

/** Called by the app shell: remembers every page except Help itself. */
export function useRememberPage() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname !== '/help') lastPath = pathname;
  }, [pathname]);
}

/** The page opened before Help (null when Help was opened first). */
export function lastPagePath(): string | null {
  return lastPath;
}

/** Signed out or expired: forget the page (it can hold a patient or bill id). */
export function forgetLastPage() {
  lastPath = null;
}
